module.exports = __webpack_public_path__ + "static/media/pause.f7bf52d6.svg";